import { EInternalPackageType, EPackageType, TAppState } from '../../types';
import { selectPackageInternalType } from './selectPackageInternalType';
import { selectPackageType } from './selectPackageType';

export const selectIsSubscription = (state: TAppState): boolean => {
  const type = selectPackageType(state);
  const internalType = selectPackageInternalType(state);

  const isAllIn = type === EPackageType.AllIn;

  const isInternalSubscriptionType = [
    EInternalPackageType.Subscription,
    EInternalPackageType.SubscriptionPublication,
    EInternalPackageType.PersonalSubscription,
    EInternalPackageType.PersonalSubscriptionPublication,
  ].includes(internalType);

  return isInternalSubscriptionType || isAllIn;
};
